import http from 'utils/http';
import {
  getBreakdownUrl,
  getDefaultSentimentKeywordsUrl,
  getGenerateSentimentKeywordsUrl,
  getSentimentSummaryUrl,
  getSignalsUrl,
  getTopKeywordsUrl
} from './apiUrls';
import { Breakdown, Signal, SignalKeywordItem, SentimentSummary, TopKeywordItem } from './types';
import { MetaApiResponse } from 'utils/types/CommonApiResponse';

export function getSignals(
  workspaceId: string,
  agentId: string,
  params?: Record<string, any>
): Promise<{ data: Signal[]; meta: MetaApiResponse }> {
  return http.get(getSignalsUrl(workspaceId, agentId), params);
}

export function getSentimentSummary(
  locationId: string,
  agentId: string,
  params?: { start_date?: string; end_date?: string }
): Promise<SentimentSummary> {
  return http.get(getSentimentSummaryUrl(locationId, agentId), params);
}

export function getBreakdown(
  locationId: string,
  agentId: string,
  params?: { start_date?: string; end_date?: string; keywords?: string[] }
): Promise<Breakdown> {
  return http.get(getBreakdownUrl(locationId, agentId), params);
}

export function getTopKeywords(
  locationId: string,
  agentId: string,
  params?: { start_date?: string; end_date?: string }
): Promise<TopKeywordItem[]> {
  return http.get(getTopKeywordsUrl(locationId, agentId), params);
}

export function getDefaultSentimentKeywords(): Promise<{ data: SignalKeywordItem[] }> {
  return http.get(getDefaultSentimentKeywordsUrl());
}

export function generateSentimentKeywords(text: string): Promise<{ data: SignalKeywordItem[] }> {
  return http.get(getGenerateSentimentKeywordsUrl(), { text });
}
